import LetterCell from './letter-cell';

export default LetterCell;
